const mobile = props => props.theme.sizes.phone;

const tablet = props => props.theme.sizes.tablet;

const desktop = props => props.theme.sizes.desktop;

export { mobile, tablet, desktop };
